// Conteúdo estático dos tours "o que mudou" do Consolidador. Os passos e alvos
// são próprios de cada tela; a chave de persistência é a compartilhada
// PAGE_HEADER_WHATSNEW, então fechar o tour numa tela marca visto nas demais e
// nos outros módulos. Ver @modules/global/constants/whatsnew.

// --- Visão Geral (rota carteira.overview) ---
// 2 passos: (1) filtros redesenhados no cabeçalho teleportado; (2) botão de
// ações primário (Baixar relatório) no slot de ações do cabeçalho.
export const CONSOLIDATOR_WHATSNEW_STEPS = [
  'Filtros redesenhados: refine a visão geral da carteira com o novo painel de filtros, agora no topo da página.',
  'Ações da página: gere os relatórios da carteira pelo novo botão de ações, reunido aqui no cabeçalho.',
]

export const CONSOLIDATOR_WHATSNEW_TARGETS = [
  '[data-tour="consolidator-overview-filters"]',
  '[data-tour="consolidator-overview-actions"]',
]

// --- Carteira Atual ---
// 3 passos, um por seção redesenhada: Mercado, Estatísticas e Distribuição.
export const CARTEIRA_ATUAL_WHATSNEW_STEPS = [
  'Indicadores de mercado com novo layout: acompanhe o cenário de mercado logo no topo da carteira.',
  'Estatísticas da carteira redesenhadas: os principais números da carteira agora aparecem de forma mais clara.',
  'Distribuição da carteira com visual renovado: entenda a alocação por classe e por ativo no novo formato.',
]

export const CARTEIRA_ATUAL_WHATSNEW_TARGETS = [
  '[data-tour="carteira-atual-mercado"]',
  '[data-tour="carteira-atual-estatisticas"]',
  '[data-tour="carteira-atual-distribuicao"]',
]

// --- Carteira atual — view viva (rota carteira.minha / minha-carteira.vue) ---
// Espelha o padrão da Visão Geral: 2 passos no cabeçalho teleportado — (1) filtros
// e (2) botão de ações. É a tela que o menu "Carteiras" realmente abre; passos
// próprios, distintos das constantes CARTEIRA_ATUAL_* (que servem ao redesign
// ainda não plugado no nav, view-carteira-atual.vue).
export const CARTEIRA_MINHA_WHATSNEW_STEPS = [
  'Filtros redesenhados: refine a carteira atual com o novo painel de filtros, agora no topo da página.',
  'Ações da página: gere os relatórios e cadastros da carteira pelo novo botão de ações, reunido aqui no cabeçalho.',
]

export const CARTEIRA_MINHA_WHATSNEW_TARGETS = [
  '[data-tour="carteira-minha-filters"]',
  '[data-tour="carteira-minha-actions"]',
]
